var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 43.5,
    cy: 43,
    rx: 43.5,
    ry: 43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 43.5,
    cy: 43,
    rx: 43,
    ry: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(29.5 36)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    className: "cls-1",
    x1: 33.427,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    className: "cls-1",
    x1: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    className: "cls-1",
    x1: 7,
    y1: 7,
    transform: "translate(0 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left-Arrow.5684ddfd9f0f7a73e149a23de9c927df.svg";
export { ForwardRef as ReactComponent };